import { h3, h5, h6, paragraph } from "@/styles/typography";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  margin-bottom: 30px;

  @media ${({ theme }) => theme.breakpoints.xs} {
    flex-direction: column;
  }
`;

const Title = styled(h3)`
  color: ${({ theme }) => theme.colors.primary};
  text-transform: uppercase;
  margin-bottom: 20px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  .gatsby-image {
    border-radius: 50%;
    width: 139px;
    height: 139px;
    object-fit: cover;
    object-position: center;
    margin-right: 20px;

    @media ${({ theme }) => theme.breakpoints.xs} {
      margin-bottom: 20px;
    }
  }
`;

const Image = styled.img`
  border-radius: 50%;
  width: 139px;
  height: 139px;
  object-fit: cover;
  object-position: center;
  margin-right: 20px;

  @media ${({ theme }) => theme.breakpoints.xs} {
    margin-bottom: 20px;
  }
`;

const Name = styled(h5)`
  color: ${({ theme }) => theme.colors.primary};
  text-transform: uppercase;
  margin-bottom: 10px;
`;

const Ul = styled.ul``;

const Li = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 5px;
  color: #424242;
`;

const LiTitle = styled(paragraph)`
  margin-right: 5px;
  color: #424242;
`;

const LiContent = styled(h6)`
  a {
    color: #424242 !important;
    text-decoration: none;
    text-transform: lowercase;
  }
  color: #424242 !important;
  margin: 0 !important;
`;

const Text = styled(paragraph)`
  max-width: 610px;
  margin-bottom: 200px;
  color: #424242;

  @media ${({ theme }) => theme.breakpoints.xs} {
    margin-bottom: 100px;
  }
`;

const S = {
  Container,
  Wrapper,
  Title,
  Image,
  Name,
  Ul,
  Li,
  LiTitle,
  LiContent,
  Text,
};

export default S;
